<template>
  <picture>
    <source
      v-if="sourcesString !== '' && isLazy"
      :data-srcset="sourcesString"
    />
    <source v-if="sourcesString !== '' && !isLazy" :srcset="sourcesString" />
    <img
      data-sizes="auto"
      :data-src="dataSource"
      :src="source"
      class="c-img o-card__image lazyautosizes lazyload"
      :alt="alt"
      :width="width"
      :height="height"
    />
  </picture>
</template>

<script>
export default {
  name: 'PictureAtom',
  props: {
    isLazy: Boolean,
    alt: String,
    modifier: String,
    sources: Array,
    src: String,
    width: Number,
    height: Number,
  },
  computed: {
    dataSource() {
      return this.isLazy ? this.src : null
    },
    source() {
      return this.isLazy && !this.$settings('noLazyLoad')
        ? 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
        : this.src
    },
    sourcesString() {
      let source = ''

      this.sources.forEach((element) => {
        source += element.url + ' ' + element.size + 'w,'
      })

      return source
    },
  },
}
</script>
